import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import "@/App.css";
import { Toaster } from "./components/ui/sonner";
import { AuthProvider, useAuth } from "./context/AuthContext";
import { SettingsProvider } from "./context/SettingsContext";
import ProtectedRoute from "./components/ProtectedRoute";
import Layout from "./components/Layout";
import Login from "./pages/Login";
import Register from "./pages/Register";
import Dashboard from "./pages/Dashboard";
import Parts from "./pages/Parts";
import Vehicles from "./pages/Vehicles";
import VehicleDetail from "./pages/VehicleDetail";
import Alerts from "./pages/Alerts";
import Services from "./pages/Services";
import Suppliers from "./pages/Suppliers";
import MyTimecard from "./pages/MyTimecard";
import Timecards from "./pages/Timecards";
import SupplyRequests from "./pages/SupplyRequests";
import Users from "./pages/Users";
import CRM from "./pages/CRM";
import CustomerDetail from "./pages/CustomerDetail";
import Inquire from "./pages/Inquire";

const FULL_ROLES = ["admin", "full"];
const ADMIN_ROLES = ["admin"];

function RedirectIfAuthed({ children }) {
  const { user, loading } = useAuth();
  if (loading) return null;
  if (user) {
    const home = user.role === "limited" ? "/my-timecard" : "/";
    return <Navigate to={home} replace />;
  }
  return children;
}

function RoleHome() {
  const { user } = useAuth();
  if (user?.role === "limited") return <Navigate to="/my-timecard" replace />;
  return <Dashboard />;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <SettingsProvider>
          <BrowserRouter>
            <Routes>
              <Route path="/login" element={<RedirectIfAuthed><Login /></RedirectIfAuthed>} />
              <Route path="/register" element={<RedirectIfAuthed><Register /></RedirectIfAuthed>} />
              <Route path="/inquire" element={<Inquire />} />
              <Route
                element={
                  <ProtectedRoute>
                    <Layout />
                  </ProtectedRoute>
                }
              >
                <Route path="/" element={<RoleHome />} />
                <Route path="/parts" element={<ProtectedRoute roles={FULL_ROLES}><Parts /></ProtectedRoute>} />
                <Route path="/vehicles" element={<ProtectedRoute roles={FULL_ROLES}><Vehicles /></ProtectedRoute>} />
                <Route path="/vehicles/:id" element={<ProtectedRoute roles={FULL_ROLES}><VehicleDetail /></ProtectedRoute>} />
                <Route path="/services" element={<ProtectedRoute roles={FULL_ROLES}><Services /></ProtectedRoute>} />
                <Route path="/suppliers" element={<ProtectedRoute roles={FULL_ROLES}><Suppliers /></ProtectedRoute>} />
                <Route path="/alerts" element={<ProtectedRoute roles={FULL_ROLES}><Alerts /></ProtectedRoute>} />
                <Route path="/my-timecard" element={<MyTimecard />} />
                <Route path="/timecards" element={<ProtectedRoute roles={ADMIN_ROLES}><Timecards /></ProtectedRoute>} />
                <Route path="/supply-requests" element={<SupplyRequests />} />
                <Route path="/users" element={<ProtectedRoute roles={ADMIN_ROLES}><Users /></ProtectedRoute>} />
                <Route path="/crm" element={<ProtectedRoute check={(u) => u.role === "admin" || u.crm_access}><CRM /></ProtectedRoute>} />
                <Route path="/crm/:id" element={<ProtectedRoute check={(u) => u.role === "admin" || u.crm_access}><CustomerDetail /></ProtectedRoute>} />
              </Route>
            </Routes>
          </BrowserRouter>
          <Toaster position="top-right" richColors />
        </SettingsProvider>
      </AuthProvider>
    </div>
  );
}

export default App;
